import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'base-additional-list',
  templateUrl: './base-additional-list.component.html',
})
export class BaseAdditionalListComponent {
  @Input({ required: true }) list: { name: string }[] = [];
  @Input() firstItemClass: string;
  @Input() plusItemClass: string;

  @HostBinding('class') hostClass = 'd-flex flex-column pt-1';
}
